angular.module('ui.shell')
    .directive('leftPanelView', function (customTemplateResolver) {
        return {
            restrict: 'E',
            replace: 'true',
            templateUrl: 'app/ui/shell/views/leftPanel.html', // customTemplateResolver.get('leftPanel.html', 'app/ui/shell/views/leftPanel.html')
            controller: function ($scope, $state, authService, $element) {

                $element.find('a').click(function () {
                    $element.blur();
                });
                /*region*/
                var flyout = $element.children().first();
                flyout.click(function () {
                    if($element.attr('focused')){
                        $element.removeAttr('focused');
                        $element.blur();
                    }else{
                        $element.attr('focused',true);

                    }
                });
                $element.blur(function () {
                    $element.removeAttr('focused');
                });

                $scope.state = $state;

                $scope.stateGo = function (event, stateToGo) {
                    event.isDefaultPrevented = false;
                    $state.go(stateToGo);
                    return true;
                };

                $scope.logout = function () {
                    authService.logout().then(
                        function (resp) {
                            $state.go('login');
                        },
                        function (resp) {
                            // something goes wrong? Nevermind!
                            $state.go('login');
                        });
                };
            }
        };
    });